export default __webpack_public_path__ + "static/gradebg5-74211104174a5ce8bb6a2e43653228db.png";